import { render, staticRenderFns } from "./MixinAvatar.vue?vue&type=template&id=5f91d5f5&"
import script from "./MixinAvatar.vue?vue&type=script&lang=js&"
export * from "./MixinAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports